// ContactIdRouteInterceptor.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ContactIdRouteInterceptor() {
  const location = useLocation();

  useEffect(() => {
    const candidateId = localStorage.getItem('partner:shine:candidateId');

    // 3️⃣ Set GA4 user_properties globally if GA is loaded
    if (candidateId && typeof window.GA?.trackGaEvent === 'function') {
      window.GA.trackGaEvent('set', 'user_properties', {
        candidateId: candidateId,
      });
    }
  }, [location]); // Runs on every route change

  return null; // No UI
}
